import type { Field, FullField, RuleType, OptionGroup } from 'react-querybuilder';
import { defaultOperators, toFullOption } from 'react-querybuilder';
import { musicalInstruments, nivelesDisponibles, asociadosDisponibles, metodosDePago } from './musicalInstruments';
import { nameOperators, numberOperators } from './operators';
//import { metodosDePago } from '../../../../helper/helper';


export const validator = (r) => !!r.value;

export const fields1 = (
  [
    /*{
      name: 'firstName',
      label: 'First Name',
      placeholder: 'Enter first name',
      validator,
    },
    {
      name: 'lastName',
      label: 'Last Name',
      placeholder: 'Enter last name',
      defaultOperator: 'beginsWith',
      validator,
    },
    { name: 'age', label: 'Age', inputType: 'number', validator },
    {
      name: 'isMusician',
      label: 'Is a musician',
      valueEditorType: 'checkbox',
      operators: defaultOperators.filter((op) => op.name === '='),
      defaultValue: false,
    },
    {
      name: 'instrument',
      label: 'Primary instrument',
      valueEditorType: 'select',
      values: musicalInstruments,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '='),
    },
    {
      name: 'alsoPlays',
      label: 'Also plays',
      valueEditorType: 'multiselect',
      values: musicalInstruments,
      defaultValue: 'more_cowbell',
      operators: defaultOperators.filter((op) => op.name === 'in'),
    },
    {
      name: 'tourStops',
      label: 'Tour stops',
      matchModes: true,
      subproperties: [
        { name: 'city', label: 'City' },
        { name: 'state', label: 'State/Province' },
        { name: 'venue', label: 'Venue' },
        { name: 'date', label: 'Date', inputType: 'date', datatype: 'date' },
        { name: 'country', label: 'Country' },
      ],
    },
    {
      name: 'gender',
      label: 'Gender',
      operators: defaultOperators.filter((op) => op.name === '='),
      valueEditorType: 'radio',
      values: [
        { name: 'M', label: 'Male' },
        { name: 'F', label: 'Female' },
        { name: 'O', label: 'Other' },
      ],
    },
    { name: 'height', label: 'Height', validator },
    { name: 'job', label: 'Job', validator },
    { name: 'description', label: 'Description', valueEditorType: 'textarea' },
    {
      name: 'birthdate',
      label: 'Birth Date',
      inputType: 'date',
      datatype: 'date',
    },
    {
      name: 'datetime',
      label: 'Show Time',
      inputType: 'datetime-local',
      datatype: 'timestamp with time zone',
    },
    { name: 'alarm', label: 'Daily Alarm', inputType: 'time' },
    { name: 'bign', label: 'Big Int', inputType: 'bigint' },
    {
      name: 'groupedField1',
      label: 'Grouped Field 1',
      comparator: 'groupNumber',
      groupNumber: 'group1',
      valueSources: ['field', 'value'],
    },
    {
      name: 'groupedField2',
      label: 'Grouped Field 2',
      comparator: 'groupNumber',
      groupNumber: 'group1',
      valueSources: ['field', 'value'],
    },
    {
      name: 'groupedField3',
      label: 'Grouped Field 3',
      comparator: 'groupNumber',
      groupNumber: 'group1',
      valueSources: ['field', 'value'],
    },
    {
      name: 'groupedField4',
      label: 'Grouped Field 4',
      comparator: 'groupNumber',
      groupNumber: 'group1',
      valueSources: ['field', 'value'],
    },*/
    {
      name: 'niveles',
      label: 'Nivel',
      valueEditorType: 'select',
      values: nivelesDisponibles,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),

      field: "category"
    },
    {
      name: 'producto',
      label: 'Producto',
      valueEditorType: 'select',
      values: nivelesDisponibles,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),

      field: "category"
    },
    {
      name: 'metodosdepago',
      label: 'Metodos de Pago',
      valueEditorType: 'select',
      values: metodosDePago,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),
    },
    {
      name: 'asociados',
      label: 'Asociado',
      valueEditorType: "select",
     // type:"",
      values: asociadosDisponibles,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),
    },
    {
      name: 'tourStops',
      label: 'Tour stops',
      matchModes: true,
      subproperties: [
        { name: 'city', label: 'City' },
        { name: 'state', label: 'State/Province' },
        { name: 'venue', label: 'Venue' },
        { name: 'date', label: 'Date', inputType: 'date', datatype: 'date' },
        { name: 'country', label: 'Country' },
      ],
    },
    {
    name: 'nestedNumberArray',
    label: 'Nested Number Array',
    // Enable specific match modes with custom labels
    matchModes: [
      { name: 'all', label: 'Every' },
      { name: 'none', label: 'Not one' },
      { name: 'some', label: 'Several' },
    ],
  },
  {
    name: 'nestedObjectArray',
    label: 'Nested Object Array',
    // Enable specific match modes with default labels
    matchModes: ['all', 'none', 'some'],
    // Define properties of objects in the nested array
    subproperties: [
      { name: 'firstName', label: 'First Name' },
      { name: 'lastName', label: 'Last Name' },
    ],
  },
  {
    //
      name: 'subquery_group',
      label: 'SUB Query',
      matchModes: true,
      subproperties: [
        { name: 'city', label: 'City' },
        { name: 'state', label: 'State/Province' },    
        { name: 'venue', label: 'Venue' },
        { name: 'date', label: 'Date', inputType: 'date', datatype: 'date' },
        { name: 'country', label: 'Country' },
        { name: 'niveles disponibles',
            label: 'Niveles Disponibles',
            valueEditorType: 'select', // Signals to use a dropdown
            values: [
                { name: 'oro', label: 'Oro' },
                { name: 'plata', label: 'Plata' },
                { name: 'bronce', label: 'Bronce' },
            ],
        },
        { name: 'metodosdepago',
      label: 'Metodos de Pago',
      valueEditorType: 'select',
      values: nivelesDisponibles,
        }

      ],
    },
    {
    //
      name: 'subquery_group33',
      label: 'SUB Nivel',
      matchModes: true,
      subproperties: [
        { name: 'niveles disponibles',
            label: 'Niveles Disponibles',
            valueEditorType: 'select', // Signals to use a dropdown
            values: [
                { name: 'oro', label: 'Oro' },
                { name: 'plata', label: 'Plata' },
                { name: 'bronce', label: 'Bronce' },
            ],
                operators: [
      { name: '=', label: 'is' },
      //...defaultOperators.filter(op => ['contains', 'beginsWith', 'endsWith'].includes(op.name)),
    ],
        },
        { name: 'metodosdepago',
      label: 'Metodos de Pago',
      valueEditorType: 'select',
      values: nivelesDisponibles,
        }

      ],
    },
  {
    //
      name: 'subquery_group',
      label: 'Nivel A',
      matchModes: true,
      subproperties: [
        { name: 'city', label: 'City' },
        { name: 'state', label: 'State/Province' },    
        { name: 'venue', label: 'Venue' },
        { name: 'date', label: 'Date', inputType: 'date', datatype: 'date' },
        { name: 'country', label: 'Country' },
        { name: 'niveles disponibles',
            label: 'Niveles Disponibles',
            valueEditorType: 'select', // Signals to use a dropdown
            values: [
                { name: 'oro', label: 'Oro' },
                { name: 'plata', label: 'Plata' },
                { name: 'bronce', label: 'Bronce' },
            ],
        },
        { name: 'metodosdepago',
      label: 'Metodos de Pago',
      valueEditorType: 'select',
      values: nivelesDisponibles,
        }

      ],
    },
  ]
).map((o) => toFullOption(o));

export const fieldsComision = (
  [
    {
      name: 'niveles',
      label: 'Nivel',
      valueEditorType: 'select',
      values: nivelesDisponibles,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),

      field: "category"
    },
    /*{
      name: 'bonificacion',
      label: 'Niveles',
      valueEditorType: 'select',
      values: nivelesDisponibles,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),

      field: "category"
    },*/
/*    {
      name: 'producto',
      label: 'Producto',
      valueEditorType: 'select',
      values: nivelesDisponibles,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),

      field: "category"
    },*/
    {
      name: 'metodosdepago',
      label: 'Metodos de Pago',
      valueEditorType: 'select',
      values: metodosDePago,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),
    },
    {
      name: 'asociados',
      label: 'Asociado',
      valueEditorType: "select",
     // type:"",
      values: asociadosDisponibles,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),
    },
  ]
).map((o) => toFullOption(o));

export const fieldsIgnorar = (
  [
    {
      name: 'bonificacion',
      label: 'Bonificación',
      valueEditorType: 'select',
      values: nivelesDisponibles,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),

      field: "category"
    },
    {
      name: 'producto',
      label: 'Producto',
      valueEditorType: 'select',
      values: nivelesDisponibles,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),

      field: "category"
    },

    {
      name: 'bonificacion',
      label: 'Bonificación',
      valueEditorType: 'select',
      values: musicalInstruments,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '='),
    },
    {
      name: 'producto',
      label: 'Producto',
      valueEditorType: "select",
     // type:"",
      values: asociadosDisponibles,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '=' || op.name === '!='),
    },
    
  ]
).map((o) => toFullOption(o));

export const fieldsOLD = [
  {
    label: 'Names',
    options: [
      { name: 'firstName', label: 'First Name', operators: nameOperators },
      { name: 'lastName', label: 'Last Name', operators: nameOperators },
    ],
  },
  {
    label: 'Numbers',
    options: [
      { name: 'height', label: 'Height', operators: numberOperators },
      { name: 'weight', label: 'Weight', operators: numberOperators },
    ],
  },
   {
    label: 'WOOp',
    options: [
      { name: 'category', label: 'CATEGORY', operators: numberOperators },
      { name: 'weight', label: 'Weight', operators: numberOperators },
    ],
  },
];
export const fieldsGO = [
  {
    label: 'Names',
    options: [
      { name: 'firstName', label: 'First Name', operators: nameOperators },
      { name: 'lastName', label: 'Last Name', operators: nameOperators },
    ],
  },
  {
    label: 'Numbers',
    options: [
      { name: 'height', label: 'Height', operators: numberOperators },
      { name: 'weight', label: 'Weight', operators: numberOperators },
    ],
  },
   {
    label: 'Nivel',
    options: [
      { name: 'category', label: 'CATEGORY', operators: numberOperators },
      { name: 'weight', label: 'Weight', operators: numberOperators },
    ],
  },
   {
    label: 'Asociado',
    options: [
      { name: 'category', label: 'CATEGORY', operators: numberOperators },
      { name: 'weight', label: 'Weight', operators: numberOperators },
    ],
  },
   {
    label: 'Metodo De Pago',
    options: [
      { name: 'category', label: 'CATEGORY', operators: numberOperators },
      { name: 'weight', label: 'Weight', operators: numberOperators },
    ],
  },
  {
      name: 'instrument',
      label: 'Primary instrument',
      valueEditorType: 'select',
      values: musicalInstruments,
      // This must be commented out to properly demonstrate `autoSelectValue={false}`
      // defaultValue: 'Cowbell',
      operators: defaultOperators.filter((op) => op.name === '='),
    },
];
